export default __webpack_public_path__ + "static/media/Twitter.85960d34.svg";